import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import "./index.css";

//—— 一次性清掉歷史 Service Worker + Cache ——
//  背景：早期版本（CRA 樣板 / 舊部署）曾註冊 Service Worker，會持續 serve 舊版靜態檔案，
//        導致老用戶進站看到破版（新 index.html 被 SW 用舊 CSS/JS 蓋掉）。
//  策略：
//    1. 若當前瀏覽器有註冊 SW → 一律 unregister
//    2. 順便清掉 SW 建立的 CacheStorage（老 SW 可能有 cache 舊資源）
//    3. 執行完不強制 reload，用戶下次進站或本次操作已無 SW 攔截
//  安全：現在專案沒使用 SW，這段永久保留無害；就算未來要加 SW 也是重新註冊，不衝突
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((r) => r.unregister());
    })
    .catch(() => {});
  if (typeof caches !== "undefined") {
    caches
      .keys()
      .then((keys) => keys.forEach((k) => caches.delete(k)))
      .catch(() => {});
  }
}

//全站 axios 都要帶 httpOnly cookie（後端登入會 Set-Cookie: token），
//  搭配後端 cors({ origin, credentials: true }) 才會作用
axios.defaults.withCredentials = true;

//攔截 401（JWT 失效 / 未登入）：丟全域事件，由 main-layout 顯示「帳號權證已失效」dialog
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent("auth-expired"));
    }
    return Promise.reject(error);
  },
);

// Flatpickr 的 positionCalendar 會對頁面上所有 stylesheet 讀 cssRules，
// cross-origin stylesheet（如 Google Fonts）會丟出 SecurityError。
// [] 是 truthy，若回傳 [] Flatpickr 會繼續嘗試 insertRule 到 cross-origin sheet，
// 同樣 SecurityError。回傳 null（falsy）才能讓 Flatpickr 的 if (sheet.cssRules) 跳過它，
// 繼續找 same-origin sheet 或自行建立 <style> 元素。
const cssRulesDescriptor = Object.getOwnPropertyDescriptor(CSSStyleSheet.prototype, "cssRules");
if (cssRulesDescriptor) {
  Object.defineProperty(CSSStyleSheet.prototype, "cssRules", {
    get() {
      try {
        return cssRulesDescriptor.get.call(this);
      } catch (e) {
        return null;
      }
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
